import type { ReactNode } from 'react';
import { ClockIcon, AlertIcon } from '@utils/icons';
import type { ListItemKind } from './model/listItem';

export type TypeTone = 'activity' | 'issue';

export interface ITypeMeta {
  labelKey: string;
  icon: (size: number) => ReactNode;
  tone: TypeTone;
}

const REGISTRY: Record<ListItemKind, ITypeMeta> = {
  activity: {
    labelKey: 'activities.type.activity',
    icon: (size) => <ClockIcon size={size} />,
    tone: 'activity',
  },
  issue: {
    labelKey: 'activities.type.issue',
    icon: (size) => <AlertIcon size={size} />,
    tone: 'issue',
  },
};

export function typeMeta(kind: ListItemKind): ITypeMeta {
  return REGISTRY[kind];
}
